export default "__VITE_ASSET__d55ee157__"